var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Modal',{ref:"loginModal",attrs:{"modal-class":'LoginModal',"show-close-icon":true,"window-max-width":"sm"}},[_vm._t("header"),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('LoginForm',{attrs:{"redirect-path":_vm.$route.path,"class-row":"form-group"}})],1),_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }